import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'userName', label: t('Permissions.table-col-1') },
    { id: 'description', label: t('Permissions.table-col-2') },
];
